module.exports = __webpack_public_path__ + "img/first.6da050eb.png";